import { ref, useRoute, watch } from '#imports';

const drawIsOpen = ref(false);
export const useDraw = () => {
  const route = useRoute();

  watch(route, () => {
    drawIsOpen.value = false;
  });

  const toggleDraw = () => {
    drawIsOpen.value = !drawIsOpen.value;
  };

  return {
    drawIsOpen,
    toggleDraw,
  };
};
